import { Link } from "react-router-dom";
import { FaArrowRight, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import CtaBanner from "../components/common/CtaBanner";
import { caseStudies } from "../data/blog";

export default function CaseStudies() {
  return (
    <>
      <PageHeader title="Case Studies" crumbs={[{ label: "Case Studies" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Case Studies"
            title="Real Results, <span>Real Impact</span>"
            text="See how we've helped businesses transform their transport operations."
          />
          <div className="grid grid-3">
            {caseStudies.map((c) => (
              <div className="card" key={c.id}>
                <Link to={`/case-studies/${c.id}`} className="blog-img">
                  <img src={c.image} alt={c.title} loading="lazy" />
                  <span className="blog-cat">{c.category}</span>
                </Link>
                <div className="blog-body">
                  <div className="blog-meta">
                    <span><FaMapMarkerAlt /> {c.location}</span>
                    <span><FaClock /> {c.duration}</span>
                  </div>
                  <h3><Link to={`/case-studies/${c.id}`}>{c.title}</Link></h3>
                  <p>Client: {c.client} — {c.industry}</p>
                  <Link to={`/case-studies/${c.id}`} className="read-more">
                    View Case Study <FaArrowRight />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
